export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const ADD_RECIPE_TO_USER_SAVED_RECIPES = "ADD_RECIPE_TO_USER_SAVED_RECIPES";
export const DELETE_RECIPE_FROM_USER_SAVED_RECIPES = "DELETE_RECIPE_FROM_USER_SAVED_RECIPES";

export const SAVE_RECIPE_WITH_SIGN_IN = "SAVE_RECIPE_WITH_SIGN_IN";